import { c as e, cB as o } from "./ghl-ui.es361.js";
import { fadeInScaleUpTransition as n } from "./ghl-ui.es1276.js";
const r = e([o("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), o("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [n({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
export {
  r as default
};
